import { useTranslation } from 'react-i18next';
import { PageControls } from './PageControls/PageControls';
import { ZoomControls } from './ZoomControls/ZoomControls';
import styles from './ControlsRow.module.css';

interface IControlsRowProps {
  /** Page navigation, for a multi-page PDF. */
  page: number;
  pageCount: number;
  onPageChange: (page: number) => void;

  /** How many of the document's annotations are currently checked. */
  shown: number;
  total: number;

  zoom: number | null;
  onZoomChange: (pct: number) => void;
  onZoomDelta: (direction: 1 | -1) => void;
}

/**
 * The strip beneath the document: where you are in it, how much of it you are
 * being shown, and how large. It belongs to the page rather than to either
 * mode — reading and drawing are navigated and zoomed the same way.
 */
export function ControlsRow({
  page, pageCount, onPageChange, shown, total, zoom, onZoomChange, onZoomDelta,
}: IControlsRowProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.row}>
      {pageCount > 1 && <PageControls page={page} pageCount={pageCount} onPageChange={onPageChange} />}
      <span>{t('documents.annotations.shownOfTotal', { shown, total })}</span>
      <div className={styles.zoom}>
        <ZoomControls zoom={zoom} onZoomChange={onZoomChange} onZoomDelta={onZoomDelta} />
      </div>
    </div>
  );
}
